export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_03.e3f6aee2.jpg";